// extracted by mini-css-extract-plugin
export var deleteModal = "_fd-0";